export default "0ee5265b0082cbc5.png"